module Sm.Core.Result

let traverse f items =
    let (>>=) x f = Result.bind f x

    (items, Ok []) 
    ||> Seq.foldBack (fun head tail ->
        f head >>= fun h ->
        tail >>= fun t -> 
            Ok (h :: t)
    )

let iter f = function
    | Ok x -> f x
    | Error _ -> ()
